import { requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
export function allowManageProfilePicture({ userState, accountId, orgMembership }) {
    // Profile picture management by system permissions
    if (requireAnySystemPermission(userState, 'manage-profile-picture') &&
        ((userState === null || userState === void 0 ? void 0 : userState.id) === accountId || requireAnySystemPermission(userState, 'manage-accounts'))) {
        return true;
    }
    // Profile picture management by organization permissions
    return orgMembership.some((id) => {
        var _a, _b, _c, _d;
        return ((_b = (_a = userState.orgPermissions) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.includes('manage-members')) &&
            ((_d = (_c = userState.orgPermissions) === null || _c === void 0 ? void 0 : _c[id]) === null || _d === void 0 ? void 0 : _d.includes('manage-profile-picture'));
    });
}
